var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEscalator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H18.95L6.95 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18C2 17.4696 2.21071 16.9609 2.58579 16.5858C2.96086 16.2107 3.46957 16 4 16H5.29L7 14.29V10C7 9.73478 7.10536 9.48043 7.29289 9.29289C7.48043 9.10536 7.73478 9 8 9H9C9.26522 9 9.51957 9.10536 9.70711 9.29289C9.89464 9.48043 10 9.73478 10 10V11.29L17.29 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6C22 6.53043 21.7893 7.03914 21.4142 7.41421C21.0391 7.78929 20.5304 8 20 8ZM8.5 5C8.89783 5 9.27936 5.15804 9.56066 5.43934C9.84197 5.72064 10 6.10218 10 6.5C10 6.89782 9.84197 7.27936 9.56066 7.56066C9.27936 7.84196 8.89783 8 8.5 8C8.10218 8 7.72064 7.84196 7.43934 7.56066C7.15804 7.27936 7 6.89782 7 6.5C7 6.10218 7.15804 5.72064 7.43934 5.43934C7.72064 5.15804 8.10218 5 8.5 5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalator);
export default __webpack_public_path__ + "static/media/escalator.0c5ac61e6c8407290c91da62b97a5feb.svg";
export { ForwardRef as ReactComponent };